export const INVENTORY_LOCATION = {
  sourceLocation: {
    label: 'Purchased - At Source Location',
    code: 'PSL'
  },
  inTransit: {
    label: 'Purchased - In Transit',
    code: 'PIT'
  },
  atDealership: {
    label: 'Checked In and At Dealership Location',
    code: 'CAD'
  },
  notDealership: {
    label: 'Checked In and Not At Dealership Location',
    code: 'CND'
  }
};
export const INVENTORY_TYPE = {
  inStock: {
    label: 'In Stock',
    code: 'I'
  },
  priceAnalysis: {
    label: 'Pricing Analysis',
    code: 'A'
  },
  problems: {
    label: 'Problems',
    code: 'P'
  },
  delivered: {
    label: 'Delivered',
    code: 'D'
  },
  funded: {
    label: 'Funded',
    code: 'F'
  }
};

// IMV
export const IMV_STATUS = {
  yes: {
    label: 'Yes',
    code: 'Y',
    variant: 'success'
  },
  no: {
    label: 'No',
    code: 'N',
    variant: 'danger'
  },
  notAvailable: {
    label: 'Not Available',
    code: 'N/A',
    variant: ''
  }
};

// STATUSES
export const DETAILS_STATUS = {
  needToDetermine: {
    label: 'Need to Determine',
    code: 'ND',
    variant: 'danger'
  },
  completed: {
    label: 'Completed',
    code: 'C',
    variant: 'success'
  },
  requestDetail: {
    label: 'Request Detail',
    code: 'DT',
    variant: 'warning'
  },
  requestClean: {
    label: 'Request Clean Up',
    code: 'CU',
    variant: 'warning'
  }
};
export const EMISSION_STATUS = {
  needToDetermine: {
    label: 'Need to Determine',
    code: 'ND',
    variant: 'danger'
  },
  completed: {
    label: 'Completed',
    code: 'C',
    variant: 'success'
  },
  requestPending: {
    label: 'Request / Pending',
    code: 'EM',
    variant: 'warning'
  }
};
export const HOMENET_STATUS = {
  notAvailable: {
    label: 'Not Available',
    code: 'NA',
    variant: 'danger'
  },
  available: {
    label: 'Available',
    code: 'AV',
    variant: 'success'
  },
  Vstatus: {
    label: 'VS ',
    code: 'VS',
    variant: 'danger'
  },
  SVstatus: {
    label: 'SV ',
    code: 'SV',
    variant: 'danger'
  }
};
export const INSPECTION_STATUS = {
  needToDetermine: {
    label: 'Need to Determine',
    code: 'ND',
    variant: 'danger'
  },
  requestPending: {
    label: 'Request / Pending',
    code: 'IN',
    variant: 'warning'
  },
  completed: {
    label: 'Completed',
    code: 'C',
    variant: 'success'
  }
};
export const KEY_STATUS = {
  notAvailable: {
    label: 'Not Available',
    code: 'NA',
    variant: 'danger'
  },
  registeredInKeyMachine: {
    label: 'Registered In Key Machine',
    code: 'R',
    variant: 'success'
  }
};
export const PICTURE_STATUS = {
  notAvailable: {
    label: 'Not Photo Available',
    code: 'NP',
    variant: 'danger'
  },
  available: {
    label: 'Available',
    code: 'A',
    variant: 'success'
  }
};
export const SPARE_KEY_STATUS = {
  customerProvide: {
    label: 'Customer to Provide',
    code: 'CP',
    variant: 'warning'
  },
  needAskCustomer: {
    label: 'Need to Ask Customer',
    code: 'AC',
    variant: 'danger'
  },
  available: {
    label: 'Available',
    code: 'AV',
    variant: 'success'
  },
  givenCustomer: {
    label: 'Sold/Delivered & Provided to Customer',
    code: 'G',
    variant: 'success'
  }
};
export const WARRANTY_STATUS = {
  needToDetermine: {
    label: 'Need to Determine',
    code: 'ND',
    variant: 'danger'
  },
  factory: {
    label: 'Factory Warranty',
    code: 'FW',
    variant: 'success'
  },
  cpo: {
    label: 'CPO Warranty',
    code: 'CW',
    variant: 'success'
  },
  dealer: {
    label: 'Dealer Warranty',
    code: 'DW',
    variant: 'success'
  },
  asIs: {
    label: 'As Is',
    code: 'AI',
    variant: 'success'
  },
  vip: {
    label: 'VIP Demo',
    code: 'VD',
    variant: 'success'
  }
};
export const MISC_STATUS = {
  needToDetermine: {
    label: 'Need to Determine',
    code: 'ND',
    variant: 'danger'
  },
  completed: {
    label: 'Completed',
    code: 'C',
    variant: 'success'
  },
  requestPending: {
    label: 'Request / Pending',
    code: 'PN',
    variant: 'warning'
  }
};

